export const mapTenant = (id) =>
  ({
    1: 'Generic',
    2: 'Sushi',
    3: 'Burgers'
  }[id] || 'Generic');
